import state from '@/store/state';
import Decoder from '@/utils/html-decoder';
import MimeTypes from '@/settings/mime-types';

export const FormatPrice = (price, fixed) => {
  if (price == 'N/A')
    return price;

  if (!price)
    price = 0;

  if (typeof fixed == 'undefined')
    fixed = 2;

  let cur = defineCurrency();

  if (price[0] === cur.sign[0])
    return price;

  return `${cur.sign_before ? cur.sign : ''}${parseFloat(price / 100).toFixed(fixed)}${!cur.sign_before ? cur.sign : ''}`;
};

export const NumberFromCurrency = (str) => {
  return Number(str.replace(/[^0-9\.-]+/g, ''));
}

const defineCurrency = () => {
  let currency;

  if (state.currencyList && state.currencyList.length && state.currencyList !== 'undefined') {
    if (state.provider.currency_id) {
      currency = state.currencyList.find(cur => cur.id == state.provider.currency_id);
    } else {
      currency = state.currencyList.find(cur => cur.code == 'usd');

      if (!currency)
        currency = state.currencyList[0];
    }
  }

  return {
    sign: Decoder(currency.sign) || '$',
    sign_before: currency.sign_before || true
  };
}

export const IsRightFileType = (file, types) => {
  if (!file || !file.type)
    return false;

  if (!types.length)
    return true;

  let res = false;

  res = types.some(type => {
    return MimeTypes[type].includes(file.type);
  });

  return res;
};

export const FormatFileSize = (bytes) => {
  let sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  
  if (bytes == 0) 
    return '0 B';

  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

  return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
};

export const CalculateProrate = (amount, prorateDate) => {
  if (!amount)
    return 0;

  let today = new Date();
  let todayDate = today.getDate();
  let daysInMonth = new Date(today.getFullYear(), (today.getMonth() + 1), 0).getDate();
  let time = new Date(today.getTime());
  time.setMonth(today.getMonth() + 1);
  time.setDate(0);
  
  let daysLeft = time.getDate() - todayDate + 1; // plus 1 to include today's day

  if (prorateDate) {
    let toDate = new Date(prorateDate).getDate();

    if (todayDate <= toDate)
      daysLeft = toDate - todayDate;
    else
      daysLeft = daysLeft + toDate - 1; // minus 1 to exclude proration date
  }

  return daysLeft ? Math.round(amount / daysInMonth * daysLeft) : amount; // if last day of month - full abount for next month
}

export const PrepareTimeList = () => {
  let h = 0;
  const list = [];

  while(h < 24) {
    const prefix = h < 12 ? 'AM' : 'PM';

    const hPref = h <= 12 ? h : h-12;
    const HH = hPref < 10 ? '0'+hPref : hPref;

    let temp = {
      label: `${HH}:00 ${prefix}`,
      value: `${h < 10 ? '0'+h : h}:00`
    }
    list.push(temp);
    
    temp = {
      label: `${HH}:30 ${prefix}`,
      value: `${h < 10 ? '0'+h : h}:30`
    }
    list.push(temp);
    h += 1;
  }
  
  return list;
}

export const FormatYear = (str) => {
  let res = '';

  if (str.length >= 4)
    res = str.substring(0, 4);
  else if (str.length == 2)
    res = `20${str}`;
  else if (str.length == 1)
    res = `202${str}`;
  else
    res = str;

  return res;
}

export const ToUpper = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
}